function WidgetIframe($window, $sce) {
  return {
    restrict: 'E',
    scope: {
      iframeSrc: '='
    },
    template: '<iframe ng-src="{{ getIframeUrl() }}" ng-style="{ \'height\' : iframeHeight }"></iframe>',
    link: function (scope) {
      scope.getIframeUrl = function () {
        return $sce.trustAsResourceUrl(scope.iframeSrc);
      };

      $window.addEventListener('message', _onIframeMessage);

      scope.$on('$destroy', () => {
        $window.removeEventListener('message', _onIframeMessage);
      });

      function _onIframeMessage(message) {
        if (message && message.data && message.data.name === 'TABLELIST_IFRAME_MESSAGE') {
          if (message.data.type === 'IFRAME_DIMENSIONS_UPDATED') {
            scope.$apply(() => {
              scope.iframeHeight = message.data.data.height;
            });
          }
        }
      }
    }
  };
}

WidgetIframe.$inject = [
  '$window',
  '$sce'
];

export default WidgetIframe;



// WEBPACK FOOTER //
// ./src/directives/widgetIframe.js